/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { getStatusBoxConfigGeneralCivilLaw } from "@/src/services/generalCivilLaw/statusBoxSteps";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import React from "react";
import { getCaseLink } from "@/src/services/productService";
import { STATUS_CREATED } from "@/src/services/litigationCase/leadStatus";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

const getButton = (generalCivilLawCase: AbstractCase) => {
  return (
    <Button component={Link} to={getCaseLink(generalCivilLawCase) + "/antrag"} variant="contained" color="primary" fullWidth>
      Weiteres Vorgehen festlegen
    </Button>
  );
};

export const getStatusBoxConfigGeneralCivilLawAdvocardFlexService = (generalCivilLawCase: AbstractCase) => {
  let boxConfig = getStatusBoxConfigGeneralCivilLaw(generalCivilLawCase);

  if (generalCivilLawCase.caseCategory === "advisory" && generalCivilLawCase.leadStatus === STATUS_CREATED) {
    return {
      ...boxConfig,
      header: "Jetzt Ihren Fall schildern",
      text: "Beschreiben Sie hier kurz in Anliegen. Danach können Sie direkt einen Termin für Ihr Erstgespräch buchen.",
      ctaButton: getButton(generalCivilLawCase),
    };
  }

  return boxConfig;
};
